<div class="td-cnt-ext">
    <div class="td-cnt">
        <div class="td-cnt-title">
            <span class="te-title">{{ 'itdcr.sendITDCR' | translate }}</span>
        </div>

        <div class="td-cnt-body">
            <div style="width:100%; display:flex; flex-direction:column; gap:12px;">

                <!-- Recipient type switch -->
                <!-- <ng-container *ngIf="millMode"> 
                    <div class="recipient-mode">
                        <label class="mode-label mr-5">{{ 'itdcr.to' | translate }} :</label>

                        <mat-button-toggle-group [value]="mode" (change)="onModeChange($event.value)"
                            name="recipientMode" aria-label="Recipient mode" class="full-width">
                            <mat-button-toggle value="office" [disabled]="!hasOffices">
                                {{ 'itdcr.recipientOffice' | translate }}
                            </mat-button-toggle>
                            <mat-button-toggle value="salesperson">
                                {{ 'itdcr.recipientSalesperson' | translate }}
                            </mat-button-toggle>
                        </mat-button-toggle-group>
                    </div>
                </ng-container> -->


                <!-- Office select (only when mode=office) -->
                <ng-container *ngIf="mode === 'office'">
                    <teiasoft-select [isMobile]="isMobile" [isRequired]="true" [disabled]="false"
                        [optionsList]="sendToOptionList!" [spaceLabel]="true" [noMinWidth]="true"
                        [isValid]="!!selectedOfficeId" [defaultValue]="selectedOfficeId"
                        [labelText]="'itdcr.to' | translate" (onSelected)="onSelectedOffice($event)" [readOnly]="false"
                        style="width: fit-content;">
                    </teiasoft-select>
                </ng-container>

                <textarea style="width:95%" rows="5" [(ngModel)]="notes"
                    [placeholder]="'commons.notes' | translate"></textarea>
            </div>
        </div>

        <div class="td-cnt-btn">
            <teiasoft-button (click)="onCloseClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                class="mr-5"></teiasoft-button>

            <teiasoft-button (click)="save()" [type]="'tb-primary'" [text]="'commons.confirm' | translate" class="mr-5"
                [disabled]="!canConfirm">
            </teiasoft-button>
        </div>
    </div>
</div>